export default __webpack_public_path__ + "static/media/DarthDick.6cc4c19f.png";